import React from "react";
import { motion } from "framer-motion";

const ABOUT_IMG = "/images/elena/elena-speaker.png";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-16 md:py-24 bg-[#F9F8F6]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20 items-start">
        {/* Headshot */}
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-5 lg:sticky lg:top-32"
        >
          <div className="relative aspect-[4/5] w-full max-w-[440px]">
            <img
              src={ABOUT_IMG}
              alt="Elena Pykhova working with a client"
              className="w-full h-full object-cover"
              data-testid="about-portrait"
              decoding="async"
              width="440"
              height="550"
              sizes="(max-width: 1024px) 100vw, 40vw"
            />
            <div className="absolute -bottom-5 -right-5 bg-[#9CDBD9] text-[#0D0D0D] px-5 py-4 max-w-[220px]">
              <p className="font-serif-display text-3xl leading-none">30+</p>
              <p className="font-sans-body text-[11px] tracking-widest-2 uppercase mt-2">
                Years in financial services risk
              </p>
            </div>
          </div>
        </motion.div>

        {/* Copy */}
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
          className="lg:col-span-7"
        >
          <p className="font-sans-body text-xs tracking-widest-2 uppercase text-[#3E7373] mb-6 flex items-center gap-3">
            <span className="inline-block w-8 h-px bg-[#3E7373]" />
            About Elena
          </p>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#0D0D0D] font-medium">
            A senior practitioner.
            <br />
            <span className="italic text-[#3E7373]">A trusted adviser.</span>
          </h2>

          <div className="mt-8 space-y-6 font-sans-body text-[16px] md:text-[17px] leading-[1.75] text-[#4A4A4A] max-w-xl">
            <p>
              I have spent three decades shaping operational risk practice inside global banks, asset managers and regulated fintechs — most recently at board and executive level. I founded my consultancy to bring that thinking to organisations seeking practical change, not presentation decks.
            </p>
            <p>
              My work sits at the intersection of governance, culture and regulatory expectation. I write, teach and speak widely on operational risk — and chair the long-standing Best Practice Operational Risk Forum, recognised across the sector for practical, principles-led guidance.
            </p>
            <p>
              Clients come to me when the stakes are real: a regulator on the doorstep, a framework that no longer fits, a board that needs an honest second opinion. I bring rigour, engagement and the kind of judgement only earned in the room.
            </p>
          </div>

          <blockquote className="mt-12 border-l-2 border-[#9CDBD9] pl-6 max-w-xl">
            <p className="font-serif-display italic text-2xl md:text-3xl text-[#3E7373] leading-snug">
              “Great risk professionals are multipliers: they strengthen judgement, improve decisions, and build resilience across the organisation, creating value far beyond the boundaries of the risk function.”
            </p>
          </blockquote>

          <div className="credentials-section mt-12 flex flex-wrap gap-x-10 gap-y-4 text-[#0D0D0D]">
            {[
              "Former Head of Op Risk, Global Bank",
              "Certified Risk Practitioner",
              "Board adviser & non-executive",
              "Published author & speaker",
            ].map((credential) => (
              <div key={credential} className="flex items-center gap-3 credential-item">
                <span className="w-1.5 h-1.5 bg-[#9CDBD9]" />
                <span className="font-sans-body text-sm">{credential}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
